import React, { useMemo } from "react"
import { Table } from "@mimber/ui-web"
import type { ColumnsType } from "@mimber/ui-web"
import { Typography } from "@mimber/ui-web"
import type { InvoiceAmountDueBreakdownTableProps } from "./InvoiceAmountDueBreakdownTable.types"
import {
  createInvoiceAmountDueBreakdownRows,
  type InvoiceAmountDueBreakdownRow,
} from "./InvoiceAmountDueBreakdownTable.utils"

const { Text } = Typography

export const InvoiceAmountDueBreakdownTable: React.FunctionComponent<
  InvoiceAmountDueBreakdownTableProps
> = ({ invoice }) => {
  const rows = useMemo(
    () => createInvoiceAmountDueBreakdownRows({ invoice }),
    [invoice]
  )

  const columns: ColumnsType<InvoiceAmountDueBreakdownRow> = useMemo(
    () => [
      {
        title: "Item",
        dataIndex: "item",
        key: "item",
        render: (item: string, record: InvoiceAmountDueBreakdownRow) =>
          record.key === "amount-due" ? <Text strong>{item}</Text> : item,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        align: "right",
        render: (amount: string, record: InvoiceAmountDueBreakdownRow) =>
          record.key === "amount-due" ? <Text strong>{amount}</Text> : amount,
      },
    ],
    []
  )

  return (
    <Table<InvoiceAmountDueBreakdownRow>
      columns={columns}
      dataSource={rows}
      rowKey="key"
      pagination={false}
      size="small"
      bordered
    />
  )
}
